const WINDOWS_RESERVED_NAME = /^(?:con|prn|aux|nul|com[1-9]|lpt[1-9])$/i;

export function createProductSlug(productName) {
  const slug = String(productName || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .toLocaleLowerCase('en-US')
    .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 100)
    .replace(/-+$/g, '');
  if (!slug) return 'producto';
  return WINDOWS_RESERVED_NAME.test(slug) ? `product-${slug}` : slug;
}

export function getProductPath(product, { trailingSlash = false } = {}) {
  const segment = createProductSlug(product?.product_name);
  return `/products/${segment}${trailingSlash ? '/' : ''}`;
}
